import React from 'react';
import { useTheme } from '../ThemeContext';

const TourPrompt = ({ detail, onStart, onSkip }) => {
  const { colors } = useTheme();

  return (
    <div
      role="dialog"
      aria-label="Take a quick tour?"
      style={{
        ...styles.card,
        background: colors.surface,
        border: `1px solid ${colors.border}`,
      }}
    >
      <p style={{ margin: '0 0 0.75rem', color: colors.text, fontWeight: 600 }}>Take a quick tour?</p>
      <p style={{ margin: '0 0 1rem', color: colors.textSecondary, fontSize: '0.9rem', lineHeight: 1.5 }}>
        {detail || 'A short walkthrough. You can skip it and open it later from More.'}
      </p>
      <div style={{ display: 'flex', gap: '0.5rem' }}>
        <button type="button" style={styles.start} onClick={onStart}>Start tour</button>
        <button
          type="button"
          style={{ ...styles.skip, background: colors.surfaceAlt, color: colors.text, border: `2px solid ${colors.border}` }}
          onClick={onSkip}
        >
          Skip
        </button>
      </div>
    </div>
  );
};

const styles = {
  card: {
    position: 'fixed',
    right: '1rem',
    bottom: 'calc(88px + env(safe-area-inset-bottom, 0px))',
    zIndex: 900,
    width: 'min(320px, calc(100% - 2rem))',
    padding: '1rem 1.1rem',
    borderRadius: '12px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
  },
  start: {
    flex: 1,
    background: 'linear-gradient(135deg, #59c4c4 0%, #4ab3b3 100%)',
    color: 'white',
    border: 'none',
    padding: '0.7rem 1rem',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '0.95rem',
  },
  skip: {
    flex: 1,
    padding: '0.7rem 1rem',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '0.95rem',
  },
};

export default TourPrompt;
